export class GeneralPreferences {
    PageSize: string = '';
    EmailFrom: string = '';
    IsActiveDirectoryUser: boolean;
    IgnoreInADPermissionUpdate: boolean;
    DefaultYearIdentifier: string = '';
    DefaultSchoolId: string = '';
    StudentNameFormat: string = '';
    StudentMiddleNameFormat: string = '';
    ShowNickname: boolean;
    PrepopulateStudent: boolean;
    DefaultCursorPosition: number;
    ShowStudentAlerts: boolean;
    MaximumAlertIcon: string = '';
    AvailableClassesOption: string[];
    SelectedClassesOption: string = '';
    SelectedClassesOptionText: string = '';
    DefaultLoginScreen: string = '';
    ShowStudentNumber: boolean;
    ShowSQLTranslation: boolean;
}